import React, { ReactNode } from 'react';

import { IntlProvider } from 'react-intl';

import { useAppSelector } from 'hooks';

interface IIntlProviderWrapperProps {
  children: ReactNode;
}

const IntlProviderWrapper = ({ children }: IIntlProviderWrapperProps) => {
  const intl = useAppSelector((state) => state.intl);

  return (
    <IntlProvider
      locale={intl.locale}
      onError={(err) => {
        /* eslint-disable no-console */
        return import.meta.env.VITE_DISABLE_INTL_ERROR ? false : console.error(err);
        /* eslint-enable no-console */
      }}
      messages={intl.messages || {}}
    >
      {children}
    </IntlProvider>
  );
};

export default IntlProviderWrapper;
